import React from 'react';
import { useLocation, useNavigate, useParams, matchPath } from 'react-router';

function withRouter(component) {
  return props => {
    const location = useLocation();
    const navigate = useNavigate();
    const params = useParams();
    const Component = component;

    const routerMatch = (options = {}) => {
      return !!matchPath(options, location.pathname);
    };

    return <Component {...props} router={{ location, params, navigate, routerMatch }} />;
  };
}

export default withRouter;
